import './Header.css';

export default function Header() {
    return (
        <header>
            <h1> 🎶🎶 Play that chooon!! 🎶🎶</h1>
            <p> Get ready for the morning squat session!! Add a song suggestion to the form below...</p>
        </header>
    );
}
